var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIconDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.09C12.93 12.09 12.42 12.315 12.03 12.6675L6.6825 9.55503C6.72 9.38253 6.75 9.21003 6.75 9.03003C6.75 8.85003 6.72 8.67753 6.6825 8.50503L11.97 5.42253C12.375 5.79753 12.9075 6.03003 13.5 6.03003C14.745 6.03003 15.75 5.02503 15.75 3.78003C15.75 2.53503 14.745 1.53003 13.5 1.53003C12.255 1.53003 11.25 2.53503 11.25 3.78003C11.25 3.96003 11.28 4.13253 11.3175 4.30503L6.03 7.38753C5.625 7.01253 5.0925 6.78003 4.5 6.78003C3.255 6.78003 2.25 7.78503 2.25 9.03003C2.25 10.275 3.255 11.28 4.5 11.28C5.0925 11.28 5.625 11.0475 6.03 10.6725L11.37 13.7925C11.3325 13.95 11.31 14.115 11.31 14.28C11.31 15.4875 12.2925 16.47 13.5 16.47C14.7075 16.47 15.69 15.4875 15.69 14.28C15.69 13.0725 14.7075 12.09 13.5 12.09Z",
    fill: "#798fad"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconDisabled);
export default __webpack_public_path__ + "static/media/share-Icon-disabled.a87cefe3449e10f69dcad21dc5970540.svg";
export { ForwardRef as ReactComponent };